module.exports = __webpack_public_path__ + "static/media/Breakfast.af5e6574.png";